import script from "./SplitPane.vue?vue&type=script&setup=true&lang=js"
export * from "./SplitPane.vue?vue&type=script&setup=true&lang=js"

import "./SplitPane.vue?vue&type=style&index=0&id=f96481ba&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f96481ba"]])

export default __exports__